import React from "react"
import { Link } from "gatsby"
import classnames from "classnames"

import * as styles from "./Footer.module.css"

export const CopyRights = ({
  hasLinkedin = true,
}: {
  hasLinkedin?: boolean
}) => (
  <span className={styles.footer__copyright}>
    Copyright © {new Date().getFullYear()} Discrete Choice Inc. All Rights
    Reserved.
    {hasLinkedin && (
      <a
        href="https://www.linkedin.com/company/pressnxpress"
        target="_blank"
        rel="noreferrer"
        aria-label="Linkedin"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          fill="#fff"
          viewBox="0 0 24 24"
          style={{ marginLeft: 15 }}
        >
          <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
        </svg>
      </a>
    )}
  </span>
)

const Footer = ({
  className,
  HideBorder = false,
}: {
  className?: string
  HideBorder?: boolean
}) => {
  return (
    <footer
      className={classnames(
        styles.footer,
        className,
        HideBorder ? styles.footer__hideBorder : ""
      )}
    >
      <div className={styles.footer__links}>
        <Link to="/about/">About</Link>
        <Link to="/contact/">Contact</Link>
        <Link to="/blog/">Blog</Link>
        <Link to="/pricing/">Pricing</Link>
        <Link to="/faq/">FAQ</Link>
        <Link to="/privacy-policy/">Privacy Policy</Link>
        <Link to="/terms-and-conditions/">Terms and Conditions</Link>
      </div>
      <CopyRights />
    </footer>
  )
}

export default Footer
